import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-input" }
const _hoisted_2 = { class: "progress-bar" }
const _hoisted_3 = {
  key: 0,
  class: "quarter-indicator"
}
const _hoisted_4 = ["data-percent-width"]
const _hoisted_5 = { class: "progress-label" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "progress-tooltip-title" }, " You cannot add data directly to your Practice summary ", -1 /* HOISTED */)
const _hoisted_7 = { class: "progress-tooltip-content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolTipComponent = _resolveComponent("ToolTipComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ToolTipComponent, null, {
      trigger: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.progressBar.ActivityType.BaseType != _ctx.BaseActivityName.Curriculum)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(["progress-indicator", _ctx.progressBar.ColourClass]),
            "data-percent-width": _ctx.progressBar.ProgressPercent / 100,
            style: _normalizeStyle({
							width: _ctx.progressBar.ProgressPercent + '%',
						})
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString(_ctx.progressBar.ProgressLabel), 1 /* TEXT */)
            ])
          ], 14 /* CLASS, STYLE, PROPS */, _hoisted_4)
        ])
      ]),
      content: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_ctx.progressBar.ProgressFor === _ctx.ProgressFor.PinkSheets)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createTextVNode(" Add new Pink Sheets"),
                _hoisted_9,
                _createTextVNode("in "),
                _createElementVNode("a", {
                  href: _ctx.progressBar.DeliverablesUrl
                }, "Deliverables", 8 /* PROPS */, _hoisted_10),
                _createTextVNode(". ")
              ]))
            : (_ctx.progressBar.ProgressFor === _ctx.ProgressFor.Curriculum)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                  _createTextVNode(" Continue your progress"),
                  _hoisted_12,
                  _createTextVNode("in "),
                  _createElementVNode("a", {
                    href: _ctx.progressBar.CurriculumUrl
                  }, "Curriculum", 8 /* PROPS */, _hoisted_13),
                  _createTextVNode(". ")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _createTextVNode(" Add " + _toDisplayString(_ctx.progressBar.DisplayLabel) + " data directly to", 1 /* TEXT */),
                  _hoisted_15,
                  _createTextVNode("the most relevant cluster's tab. ")
                ]))
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}